import { Global } from '@emotion/react';
import styled from '@emotion/styled';
import type { ReactNode } from 'react';
import { topPageStyle } from '../../../styles';
import { Body } from './Body';
import { LoginError } from './LoginError';

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 800px;
`;

const ProPlusImg = styled.img`
  flex: 1;
  padding: 10px;
  margin-bottom: 30px;
  width: 500px;
  height: 126px;
`;

const LoginCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 450px;
  padding: 0;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #eeeeee;
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 15px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ccc;
  font-size: 18px;
  font-weight: bold;
`;

const CardContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

interface LoginContainerProps {
  title: string;
  children: ReactNode;
  error: string | null;
}

export function LoginContainer({ title, children, error }: LoginContainerProps) {
  return (
    <Body>
      <Global styles={topPageStyle} />
      <Layout>
        <ProPlusImg src="images/proplus_logo.png" alt="ProPlus+" />
        <LoginCard>
          <CardHeader id="title">{title}</CardHeader>
          <CardContent>{children}</CardContent>
        </LoginCard>
        <LoginError error={error} />
      </Layout>
    </Body>
  );
}
